import { render, staticRenderFns } from "./PaypalCompleted.vue?vue&type=template&id=39662c60&scoped=true"
import script from "./PaypalCompleted.vue?vue&type=script&lang=js"
export * from "./PaypalCompleted.vue?vue&type=script&lang=js"
import style0 from "./PaypalCompleted.vue?vue&type=style&index=0&id=39662c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39662c60",
  null
  
)

export default component.exports